// import MainLayout from 'layout/MainLayout';
// import HeaderLayout from 'layout/HeaderLayout';
import MinimalLayout from 'layout/MinimalLayout';
import React from 'react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
// kyc/profile routes...
const Kyc = Loadable(lazy(() => import('views/user-components/pages/profile/Kyc')));
const AssetClassBreakdown = Loadable(lazy(() => import('views/user-components/pages/profile/AssetClassBreakdown')));
const ClientAccounts = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/ClientAccount')));
const ClientList = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/client-form/ClientList')));
const ClientTransaction = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/ClientTransaction.jsx')));
const ClientNotes = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/ClientNotes')));
const ChangeLogDetails = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/ChangeLogDetails')));
const ChangeLogHistory = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/ChangeLogHistory')));
const DashboardForm = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/DashboardForm')));
const ClientDownloadForm = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/ClientDownloadForm')));
const AnnualReport = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/AnnualReport')));
const RiskAssessment = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/RiskAssessment')));
const ClientFormSteps = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/client-form/ClientFormSteps')));
const ClientCombinedFormOptimize = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/client-form/client-combined-form/ClientCombinedForm')));
// const ClientCombinedForm = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/client-form/ClientCombinedForm')));
const ClientThankYouPage = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/client-form/ClientThankYouPage')));
// const Home = Loadable(lazy(() => import('views/user-components/pages/dashboard/Home')));

const AgreementDocs = Loadable(lazy(() => import('views/user-components/pages/profile/client-details/client-form/AgreementDocs')));
const AumSummary = Loadable(lazy(() => import('views/common-components/aum-summary/AumSummary')));


let loginType = localStorage.getItem('login_type');
let login_id = localStorage.getItem('login_id');
let userId = localStorage.getItem('user_id');
let dashboardLogin = localStorage.getItem('dashboard_login'); //when you access to dashboard
let isSuperUserLogin = (loginType === 'dashboard_admin' || loginType === 'portfolio_manager');
let isClientLogin = loginType === 'client';

const ProtectedRoute = ({ element, isAccessible }) => {

    // TODO:: this is temp solution, find proper solution when get time...
    if (isSuperUserLogin && !dashboardLogin) {
        return element;
    }
    // for admin and  PM login
    if (isSuperUserLogin) {
        return element;
        // return <Navigate to={`/kyc/client-form/${login_id}`} />;
    }
    // when client login
    if (isClientLogin && isAccessible) {
        return element
    }
    return ((isAccessible) && (isSuperUserLogin || isClientLogin)) ? element : <Navigate to={'/'} />;
};

// console.log(isSuperUserLogin)

const ProfileRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/kyc',
            element: <ProtectedRoute element={<Kyc />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/asset-class-breakdown',
            element: <ProtectedRoute element={<AssetClassBreakdown />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/client-accounts',
            element: <ProtectedRoute element={<ClientAccounts />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/client-list',
            element: <ProtectedRoute element={<ClientList />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/client-transaction/:id',
            element: <ProtectedRoute element={<ClientTransaction />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/client-notes/:userId',
            element: <ProtectedRoute element={<ClientNotes />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/change-log-details/:userId/:logId',
            element: <ProtectedRoute element={<ChangeLogDetails />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/change-log-history/:userId',
            element: <ProtectedRoute element={<ChangeLogHistory />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/dashboard-form',
            element: <ProtectedRoute element={<DashboardForm />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/dashboard-download-form/:id/:subId',
            element: <ProtectedRoute element={<ClientDownloadForm />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/annual-report',
            element: <ProtectedRoute element={<AnnualReport />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/risk-assessment/:id',
            element: <ProtectedRoute element={<RiskAssessment />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/kyc/client-form/:id',
            element: <ProtectedRoute element={<ClientFormSteps />} isAccessible={isSuperUserLogin} />
        },
        {
            path: '/client/client-form/:id',
            element: <ProtectedRoute element={<ClientCombinedFormOptimize />} isAccessible={true} />
        },
        {
            path: '/client/client-form-optimize/:id',
            element: <ProtectedRoute element={<ClientCombinedFormOptimize />} isAccessible={true} />
        },
        {
            path: '/client/thank-you',
            element: <ProtectedRoute element={<ClientThankYouPage />} isAccessible={true} />
        },

        // { path: '/admin/agreement-docs/:id', element: isAdminLogin ? <AgreementDocs /> : <Navigate to={'/admin'} /> },
        {
            path: '/kyc/agreement-docs/:id',
            element: <ProtectedRoute element={<AgreementDocs />} isAccessible={true} />
        },
        {
            path: '/kyc/aum-summary',
            element: <ProtectedRoute element={<AumSummary />} isAccessible={true} />
        },
    ]
};
export default ProfileRoutes;
